import { useCallback, useRef } from 'react';

import { useModalContext } from '~/provider/ModalProvider';

/**
 * Note: This hook is intended for modals that do not require any dynamic data to be passed in.
 * In the future, if we need to support dynamic data, we can extend this hook or create a new one.
 */
type ModalIds =
  | 'need-help'
  | 'promotion-information'
  | 'rebate-assistance'
  | 'filter-vendors'
  | 'sort-vendors'
  | 'landing-information'
  | 'selected-vendor'
  | 'premarketplace';

export const useModal = (id: ModalIds) => {
  const { openModal, closeModal, isOpenModal } = useModalContext();
  const ref = useRef<HTMLButtonElement>(null);

  const onCloseAutoFocus = useCallback((event: Event) => {
    event.preventDefault();
    ref.current?.focus();
  }, []);

  const isOpen = isOpenModal(id);
  const open = useCallback(() => openModal(id), [id, openModal]);
  const close = useCallback(() => closeModal(), [closeModal]);

  return {
    isOpen,
    open,
    close,
    ref,
    onCloseAutoFocus,
  };
};
